<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: ['فروردین',
        'اردیبهشت',
        'خرداد',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند'],
      datasets: [
        {
          defaultFontFamily: 'Vazir FD',
          label: 'میزان فروش',
          backgroundColor: '#33333300',
          borderColor: '#333333',
          pointBackgroundColor: '#333333',
          pointBorderColor: '#333333',
          pointRadius: 2,
          borderWidth: 2,
          pointHitRadius: 2,
          data: [0, 217, 126, 240, 56, 34, 619, 85, 298],
        },
        {
          defaultFontFamily: 'Vazir FD',
          label: 'میزان پیشرفت',
          backgroundColor: '#45886500',
          borderColor: '#458865',
          pointBackgroundColor: '#458865',
          pointBorderColor: '#458865',
          pointRadius: 2,
          borderWidth: 2,
          pointHitRadius: 2,
          data: [10, 17, 326, 220, 156, 134, 219, 185, 198],
        },
      ],
    }, {
      defaultFontFamily: 'Vazir FD',
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 1,
      scales: {
        tick: {
          fontFamily: 'Vazir FD',
        },
        xAxes: [{
          gridLines: {
            color: 'rgba(0, 0, 0, 0)',
            fontFamily: 'Vazir FD',
            drawBorder: true,
            zeroLineColor: '#ffcc3300',
          },
          ticks: {
            display: true,
            fontFamily: 'Vazir FD',
            fontSize: 10,
          },
        }],
        yAxes: [
          {
            gridLines: {
              color: 'rgba(0, 0, 0, 0.05)',
              drawBorder: true,
              zeroLineColor: '#00000033',
              fontFamily: 'Vazir FD',
            },
            ticks: {
              fontFamily: 'Vazir FD',
              fontSize: 10,
              display: true,
            },
          }],
      },
      layout: {
        padding: 16,
      },
      legend: {
        display: true,
        font: {
          size: 16,
          family: 'Vazir FD',
        },
      },
    }, [

    ]);
  },
};
</script>

<style lang="scss" scoped>
canvas {
  height: 250px !important;
}
</style>
